// Utility function to format currency in Kenyan Shillings (KES)
export const   formatCurrency=(amount)=> {
    const formatter = new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 2,
    });
    return formatter.format(amount);
  }
  